
import HTMLRenderer from './../../zviz2/zviz/renderers/html';

import Group from './../../zviz2/zviz/components/group';
import Link from './../../zviz2/zviz/components/link';
import SimpleEvent from './../../zviz2/zviz/event';


import MapBlueprint from './components/map/blueprint';

import {extend, cloneObject} from './../../zviz2/zviz/functions';
import {getSizeWatcher} from './../../zviz2/zviz/environment/window';
import state from './../../zviz2/zviz/state';
import global from './../../zviz2/zviz/global';

let scripts = document.getElementsByTagName('script');
let scriptNode = document.currentScript || scripts[scripts.length - 1];

// idee:
/* 
properties: {
    namespace: null,
    name: 'a_unique_name_in_the_namespace'
}

children by default get the same namespace. If a new namespace is given it
will add to the existing: 'namespace1.namespace2'

getObjectsByName(name, namespace=null){
    // returns a list of object with the name in the current namespace
    // or the one provided
}

states kunnen global of met de namespace worden gebruikt.
state.get(namespace + '.tooltip');

maar hoe kun je terug naar de 'juiste' namespace laag...?

*/

class Component{

    constructor(settings={}){
        
        settings = extend(settings, {
            container: null,
            colors: {
                normal: [1, 104, 155, 0.3],
                highlight: [202, 0, 93, 1]
            },
            language: 'english',
            selectedCountries: [],
            title: '',
            zoom: false,
            height: 'auto'
        });

        this.objects = [];
        this.objects.push(getSizeWatcher());

        let BlueprintM = extend({
            properties: {
                data: {
                    height: (ctrl) => ( state.get('windowSize.width')<700? 250: 600),
                    width: 'auto',
                    maxScale: 800,
                    selected: settings.selectedCountries,
                    colors: settings.colors,
                    highlight: true,
                    title: settings.title,
                    zoom: settings.zoom,
                    language: settings.language
                },
                style: {

                }
            },
            
        }, MapBlueprint);

        let Download = [];
        if(window.enableSvgDownload){
            Download = extend({
                properties: {
                    style: {
                        border: '1px solid #ccc',
                        borderRadius: '5px',
                        padding: '5px 10px',
                        position: 'absolute',
                        bottom: '20px',
                        right: '20px',
                        backgroundColor: 'white'
                    },
                    attributes: {
                        href: '#'
                    },
                    content: 'Save SVG'
                },
                events: {
                    click: (event, ctrl) => {
                        event.preventDefault();
                        let c = ctrl.getByUid('svgMap');
                        if(c.renderOutput && c.renderOutput.result){
                            document.getElementById('downloadSvgContent').value = c.parent.renderOutput.result.innerHTML;
                            document.getElementById('downloadSvg').submit();
                        }
                    }
                }
            }, Link);
        }

        let Blueprint = extend({
            children: [
                BlueprintM,
                // cloneObject(Tooltip)
                Download
            ],
            properties: {
                style: { 
                    position: 'relative'
                 }
            },
            listeners: [
            ]
        }, Group);

        let container = settings.container;
        if(container == null){
            container = scriptNode.parentNode;
        }else if(typeof container == 'string'){
            container = document.getElementById(container);
        }

        let renderer = new HTMLRenderer();
        renderer.setCanvas(container);
        renderer.start(Blueprint);

        this.objects.push(renderer);

        let select = document.getElementById('countrySelect');
        if(select){
            let event = new SimpleEvent(select, 'change', [this, this.countrySelect]);
            this.objects.push(event);

            state.addResponder('map.countryHighlight', [this, this.setCountry]);
        }

    }

    countrySelect(event){
        let elm = event.currentTarget;
        let val = countryValues[elm.value] || false;
        state.set('map.countryHighlight', val);
    }

    setCountry(){
        let select = document.getElementById('countrySelect');
        if(! select){
            return;
        }
        let val = state.get('map.countryHighlight');
        let elms = document.getElementsByClassName('countryInfo');
        for(let i = 0; i < elms.length; i++){
            elms[i].style.display = 'none';
        }        
        if(! val){
            select.value = '';
            document.getElementById('selectCountry').style.display = 'block';
            select.style.fontWeight = 'normal';
            select.style.fontStyle = 'italic';
        }else{
            let found = false;
            for(let k of Object.keys(countryValues)){
                if(val.type == countryValues[k].type && val.value == countryValues[k].value){
                    select.value = k;
                    document.getElementById(k).style.display = 'block';
                    select.style.fontWeight = 'bold';
                    select.style.fontStyle = 'normal';
                    found = true;
                }
            }
            if(! found){
                if(val.region){
                    state.set('map.countryHighlight', {type: 'region', value: val.region});
                }else{
                    state.set('map.countryHighlight', null);
                }
            }
        }
    }

    remove(){
        for(let o of this.objects){
            if(! (o instanceof Function)){
                o.remove();
            }
        }
        delete this.objects;
    }

}    

export default Component;



